import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export interface IParamasGetInquiryAnalitic {
  startDate?: string,
  endDate?: string,
  countType: string
}
export const GetInquiryAnalyticsService = async (params: IParamasGetInquiryAnalitic) => {
  const response: any = await getByQuery<any>(`${services.analytics}/inquiry-analytics`, params);
  return response?.data;
};